var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_225_105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 11.228C7.9962 11.228 2 12.7326 2 15.7192V16.842C2 17.4595 2.50629 17.9648 3.12502 17.9648H5.77357C5.87567 15.1672 8.17231 12.9182 11 12.9182C13.8277 12.9182 16.1243 15.1672 16.2264 17.9648H18.875C19.4938 17.9648 20 17.4595 20 16.842V15.7192C20 12.7326 14.0037 11.228 11 11.228Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 8.9824C13.4862 8.9824 15.5 6.97254 15.5 4.49116C15.5 2.00979 13.4862 0 10.9999 0C8.51372 0 6.5 2.00979 6.5 4.49116C6.5 6.97254 8.51372 8.9824 10.9999 8.9824Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 14.3071C8.93627 14.3071 7.2657 15.93 7.16502 17.9648C7.16188 18.0286 7.146 18.0888 7.146 18.1535C7.146 20.2779 8.87147 22 11 22C13.1285 22 14.854 20.2779 14.854 18.1535C14.854 18.0888 14.8381 18.0286 14.8349 17.9648C14.7343 15.93 13.0637 14.3071 11 14.3071ZM13.546 18.5858L11.4949 20.6329C11.3796 20.748 11.2263 20.8115 11.0634 20.8115C10.9005 20.8115 10.7473 20.748 10.6319 20.6329C10.5165 20.5177 10.453 20.3642 10.453 20.2007C10.453 20.037 10.5165 19.8835 10.6319 19.7684L11.6387 18.7635H8.88623C8.54922 18.7635 8.27506 18.4899 8.27506 18.1536C8.27506 18.0867 8.29334 18.0251 8.31334 17.9648C8.39402 17.7221 8.61626 17.5435 8.88623 17.5435H11.6408L10.635 16.5355C10.3971 16.2981 10.3971 15.9117 10.635 15.6741C10.7504 15.559 10.9036 15.4956 11.0665 15.4956C11.2295 15.4956 11.3827 15.559 11.4984 15.6745L13.5461 17.7244C13.6157 17.7938 13.6585 17.8773 13.6874 17.9648C13.7573 18.1764 13.7144 18.4177 13.546 18.5858Z",
    fill: "#767676"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_225_105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 22,
    fill: "white",
    transform: "translate(2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalPerson);
export default __webpack_public_path__ + "static/media/ExternalPerson.567692ae1ae5bb44d08b13f6dde7fb43.svg";
export { ForwardRef as ReactComponent };